import type { IValidatedResponse } from '../../httpClient';
import { putRequest } from '../../httpClient';
import type { IUpdateChallengeTranslationRequest } from './update-challenge-translation-request';
import type { IUpdateChallengeTranslationResponse } from './update-challenge-translation-response';
import { updateChallengeTranslationResponseSchema } from './update-challenge-translation-response';

export async function updateChallengeTranslationApi({
  challengeId,
  translationId,
  body,
}: IUpdateChallengeTranslationRequest): Promise<
  IValidatedResponse<IUpdateChallengeTranslationResponse>
> {
  return putRequest<IUpdateChallengeTranslationResponse>({
    path: `/sys/challenges/${challengeId}/translations/${translationId}`,
    body,
    schema: updateChallengeTranslationResponseSchema,
  });
}
